'use client';
import { useRef, useEffect } from 'react';

function usePreventVerticalScroll(r, n = 5) {
    let c = useRef(0), o = useRef(0);
    useEffect(()=>{
        let preventTouch = (t)=>(o.current = t.touches[0].clientX - c.current, !(Math.abs(o.current) > n) || (t.preventDefault(), false)), touchStart = (t)=>{
            c.current = t.touches[0].clientX;
        }, t = null == r ? void 0 : r.current;
        return t && (t.addEventListener('touchstart', touchStart), t.addEventListener('touchmove', preventTouch, {
            passive: false
        })), ()=>{
            t && (t.removeEventListener('touchstart', touchStart), t.removeEventListener('touchmove', preventTouch));
        };
    });
}

export { usePreventVerticalScroll };
